// @flow
/* eslint-disable promise/always-return */

import superagent from 'superagent'
import Cache from 'stale-lru-cache'
import flatMap from 'array.prototype.flatmap'
import feed from './feed.json'

flatMap.shim()

let cache

type cacheConfig = {
  maxAge: number,
  staleWhileRevalidate: number
}

type FeedResult = {
  feed: any[],
  tags: any[]
}

const feedKey = 'feed'

const getFeed = (feedId) => {
  // return superagent
  //   .get(`https://redutv-api.vg.no/sports/question/${feedId}`)
  //   .then(res => res.body)
  //   .then(feed => {
  //     const tags = getTags(feed)
  //     return { feed, tags }
  //   })

  return Promise.resolve(feed)
    .then(feed => {
      const tags = getTags(feed)
      return { feed, tags }
    })
}

function getTags (feed) {
  return feed
    .flatMap(feedItem => feedItem.data.superTags)
    .filter(item => !!item) // remove empty tags
    .reduce((tags, item) => {
      const slug = item.slug
      if (tags[slug]) {
        tags[slug].count++
      } else {
        tags[slug] = {
          ...item,
          count: 1
        }
      }
      return tags
    }, {})
}

export function getFeedCached (feedId: string, config: cacheConfig): Promise<FeedResult[]> {
  if (!cache) {
    cache = new Cache({
      maxSize: 100,
      maxAge: config.maxAge || 600,
      staleWhileRevalidate: config.staleWhileRevalidate || 86400
    })
  }

  const revalidate = (key, callback) => {
    getFeed(feedId)
      .then(feedResult => callback(null, feedResult))
      .catch(error => callback(error))
  }

  return new Promise((resolve, reject) => {
    if (cache.has(feedKey)) {
      resolve(cache.get(feedKey))
    } else {
      getFeed(feedId)
        .then((feedResult) => {
          cache.set(feedKey, feedResult, { revalidate })
          resolve(feedResult)
        })
        .catch(reject)
    }
  })
}

export function getFeedFiltered (feedId: string, config: cacheConfig, tag?: string): Promise<FeedResult[]> {
  return getFeedCached(feedId, config).then(feedResult => {
    const { feed, tags } = feedResult

    const filteredFeed = feed.filter(feedItem => {
      const tags = (feedItem.data.superTags || []).map(tag => tag.slug)
      return !tag || tags.indexOf(tag) !== -1
    })
    return { feed: filteredFeed, tags }
  })
}

export function sendQuestion (feedId: string, fromName: string, text: string) {
  return superagent
    .post(`https://redutv-api.vg.no/sports/question/${feedId}`)
    .type('form')
    .send({ fromName, text })
    .then(res => res)
}
